import 'motivate-framework/dist/css/motivate.css';
import Vue from 'vue';
import {initIl8n} from './plugins/i18n';
import 'sweetalert2/dist/sweetalert2.min.css';

import App from './App.vue';
import router from './router/index';
import store from './store';
import './init/components/importGlobalFrameworkComponents';
import './init/components/importGlobalComponents';
import './init/importGlobalFilters';
import './init/importGlobalEventBus';
import './registerServiceWorker';
import initFirebase from './init/initFireBase';
import MotivateAuth from './init/auth';
import {getParameters} from './init/generalFunctions';
import MotivateCloudApi from './init/initCloudApi';
import BarcodeScanner from 'vue-zebra-barcode-scanner';
import onScan from './init/HIDScanner';
import isMobile from './plugins/isMobile';

Vue.prototype.$BluetoothScan = onScan;
window._ = require('lodash');
window.moment = require('moment');


Vue.config.performance = true;
Vue.prototype.$auth = new MotivateAuth({
  client: {
    id: isMobile.check() ? process.env.VUE_APP_CLIENT_ID_APP : process.env.VUE_APP_CLIENT_ID_BROWSER, //'c659a66c-e9e7-4fbd-b034-55de76860ec7', //process.env.VUE_APP_CLIENT_ID
    redirectUri: isMobile.check() ? process.env.VUE_APP_REDIRECT_URI_APP : process.env.VUE_APP_REDIRECT_URI_BROWSER, // 'floordevice://callback', //process.env.VUE_APP_REDIRECT_URI
    scope: 'offline_access'
  }
});

if(isMobile.check()) {
  document.addEventListener('deviceready', initializeAppBeforeRender, false);
} else {
  initializeAppBeforeRender().catch(e => {
    alert(e);
  }); //this is the browser
}


async function initializeAppBeforeRender() {
  window.handleOpenURL = async function (url) {
    let params = getParameters(url.replace(/.*\/callback\?/, ''));
    if(params.code) {
      await Vue.prototype.$auth.login(params.code);
      await initalizeAppRender();
    } else {
      window.location = '/';
    }
  };
  initalizeAppRender();
}

async function desktopCallback(code) {
  await Vue.prototype.$auth.login(code);
  return true;
}

async function initalizeAppRender() {
  // If desktop we get the data different then on the app
  // Therefore we need to parse the authentication code differently
  if(!isMobile.check() && window.location.href.indexOf('callback') > -1) {
    const params = getParameters(window.location.href.replace(/.*\/callback\?/, ''));
    if (params.code) {
      await desktopCallback(params.code);
    }
  }

  let isAuthenticated = await Vue.prototype.$auth.checkAuthentication();
  let token = await Vue.prototype.$auth.getOauthToken();

  if(!isAuthenticated || !token) {
    window.location = Vue.prototype.$auth.getLoginUrl();
  } else {
    Vue.prototype.$CLOUD_API = new MotivateCloudApi(token).getCloudApi();
    Vue.prototype.$CLOUD_API('/authentication/firebasetoken').then((token) => {
       let user = Vue.prototype.$auth.getUser();

      store.commit('users/setMe', user);

      initFirebase(token).then(async (res) => {
        let config = await getConfig(Vue.prototype.$auth.getUser().company.id.toString());
        Vue.prototype.$APP_CONFIG = config;
        if(isMobile.check()) {
          document.addEventListener('deviceready', () => {
            Vue.prototype.$SCANNER_CONFIG = new BarcodeScanner('com.motivate.scanner', config.scanner ? config.scanner : null);
          }, false);
        } else {
          Vue.prototype.$SCANNER_CONFIG = new BarcodeScanner('com.motivate.scanner', config.scanner ? config.scanner : null);
        }
        var i18n = initIl8n(config);
        renderVue(i18n);
      }).catch(e => {
        console.error(e);
      });
    });
  }
}

async function getConfig(companyId) {
  try {
    let doc = await Vue.prototype.$FB.collection('config').doc(companyId).get();
    return doc.data();
  } catch (e) {
    console.error(e);
  }
}

function renderVue(i18n) {
  new Vue({
    router: router,
    store: store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}
